import { render, staticRenderFns } from "./super-admin-header.vue?vue&type=template&id=40b56acd&scoped=true&"
import script from "./super-admin-header.vue?vue&type=script&lang=js&"
export * from "./super-admin-header.vue?vue&type=script&lang=js&"
import style0 from "./super-admin-header.vue?vue&type=style&index=0&id=40b56acd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b56acd",
  null
  
)

export default component.exports